const subject = [
  {
    title: "支气管镜操作适应证：《诊断性可弯曲支气管镜应用指南（2008年版）》",
    type: "checkbox",
    options: [
      {
        label: "不明原因的慢性咳嗽"
      },
      {
        label: "不明原因的咯血或痰中带血"
      },
      {
        label: "不明原因的局限性哮鸣音"
      }
    ]
  },
  {
    title: "支气管镜操作适应证：《诊断性可弯曲支气管镜应用指南（2008年版）》",
    type: "radio",
    options: [
      {
        label: "不明原因的慢性咳嗽"
      },
      {
        label: "不明原因的咯血或痰中带血"
      }
    ]
  }
];

const questionnare = [
  {
    title: "1.（单选）专科医师规范化培训属于医学教育的哪个阶段（）",
    answer: "B",
    options: [
      { label: "院校教育阶段" },
      { label: "毕业后教育阶段" },
      { label: "继续教育阶段" },
      { label: "职业教育阶段" },
      { label: "以上均错" }
    ]
  },
  {
    title: "2.（单选）PCCM专培培训细则中要求轮转的科室包括（）",
    answer: "E",
    options: [
      { label: "呼吸病房与门诊" },
      { label: "MICU/RICU" },
      { label: "肺功能、支气管镜、呼吸睡眠障碍等专科技术科室" },
      { label: "EICU、CCU、SICU等专科ICU" },
      { label: "以上均是" }
    ]
  },
  {
    title: "3.（单选）以下关于PCCM专培中呼吸病房轮转的要求中错误的是（）",
    answer: "D",
    options: [
      { label: "呼吸病房轮转时长为14个月" },
      { label: "学员在轮转期间负责呼吸疾病的诊疗和会诊" },
      { label: "呼吸病房轮转可包括呼吸科住院总医师" },
      { label: "呼吸病房轮转可包括大内科住院总医师" },
      { label: "专培第三年必须轮转呼吸病房" }
    ]
  },
  {
    title: "4.（单选）以下关于PCCM专培中技能操作的要求中正确的是（）",
    answer: "C",
    options: [
      { label: "气管镜操作对于活检例数没有要求" },
      { label: "呼吸机管理例数≥50例，其中包括无创机械通气例数" },
      { label: "中心静脉穿刺置管≥50例" },
      { label: "14 导联睡眠试验报告≥200例" },
      { label: "心肺运动试验为可选技能操作，无具体例数要求" }
    ]
  },
  {
    title: "5.（单选）以下关于PCCM专培中教学大查房的要求中错误的是（）",
    answer: "D",
    options: [
      { label: "教学大查房必须使用诊断已明确的病例" },
      { label: "教学大查房内容中应包括对诊疗方案的讨论" },
      { label: "教学大查房应由专培医师主导" },
      { label: "教学大查房的频次要求为至少每月1次" },
      { label: "教学大查房的病例可来源于普通呼吸病房及MICU/RICU" }
    ]
  },
  {
    title: "6.（单选）以下对于PCCM专培师资资格的描述中错误的是（）",
    answer: "C",
    options: [
      { label: "核心师资应具备博士学位" },
      { label: "核心师资应具备副高级以上职称" },
      {
        label:
          "核心师资应在在本单位或三级甲等教学医院从事PCCM专科（或轮转范围内相关专业）医、教、研工作超过20年"
      },
      { label: "凡属于轮转内容范围内的科室必须具备至少1名专培师资" },
      { label: "每名专培师资同时指导的专培医师不得超过2名" }
    ]
  },
  {
    title: "7.（单选）专培医师的考核有哪几种形式？",
    answer: "E",
    options: [
      { label: "日常查房、教学查房" },
      { label: "现场考核" },
      { label: "年度考核" },
      { label: "结业考核" },
      { label: "以上均是" }
    ]
  },
  {
    title: "8.（单选）以下关于PCCM专培基地资质要求中错误的是（）",
    answer: "B",
    options: [
      { label: "已正式更名为“呼吸与危重症医学科”" },
      { label: "基本床位数≥50张（包括MICU或RICU床位数）" },
      { label: "科室年出院患者数≥1,300人次，年门诊量≥15,000人次" },
      { label: "需具有呼吸与危重症医学科所属MICU或RICU" },
      { label: "MICU和(或)RICU床位数总和≥15张，年收治患者数≥400例" }
    ]
  },
  {
    title: "9.（单选）教学查房的步骤顺序是什么？",
    answer: "C",
    options: [
      { label: "补充汇报-分析讨论-汇报病例-小结-上级医师指导" },
      { label: "分析讨论-补充汇报-汇报病例-小结-上级医师指导" },
      { label: "汇报病例-补充汇报-上级医师指导-分析讨论-小结" },
      { label: "小结-上级医师指导-汇报病例-补充汇报-分析讨论" },
      { label: "上级医师指导-汇报病例-补充汇报-分析讨论-小结" }
    ]
  },
  {
    title: "10.（单选）PCCM专培医师的需求包括？",
    answer: "E",
    options: [
      { label: "专科知识" },
      { label: "专科技能" },
      { label: "科研能力" },
      { label: "职业发展规划" },
      { label: "以上均是" }
    ]
  },
  {
    title: "11.（单选）PCCM专培细则中要求学员在MICU/RICU轮转时间为（）",
    answer: "D",
    options: [
      { label: "3个月" },
      { label: "4个月" },
      { label: "5个月" },
      { label: "6个月" },
      { label: "7个月" }
    ]
  },
  {
    title: "12. （单选）以下哪项不是对取得PCCM专培师资资格的要求（）",
    answer: "C",
    options: [
      { label: "完成线下培训" },
      { label: "完成线上培训" },
      { label: "在所在地省级卫生机构申报" },
      { label: "完成线上考核" },
      { label: "持证上岗" }
    ]
  },
  {
    title: "13. （单选）以下对于PCCM专培基地招生要求的说明错误的是（）",
    answer: "D",
    options: [
      { label: "专科基地应在招生简章中明确培训对象待遇" },
      { label: "专科基地每年招收培训对象不低于3人" },
      { label: "原则上至少招收1名外单位委派培训对象或社会人员" },
      { label: "原则上本单位学员占全部学员的比例不得超过80%" },
      { label: "指导医师与培训对象的比例应达到1:2" }
    ]
  },
  {
    title: "14. （单选）PCCM专培学员参加结业考核前审核培训内容完成情况的依据是（）",
    answer: "A",
    options: [
      { label: "线上培训过程管理平台培训日志填报数据" },
      { label: "纸版培训日志填报数据" },
      { label: "专科基地项目主任签字的培训报告" },
      { label: "专科基地所在医院教学行政管理部门盖章的培训报告" },
      { label: "专培学员编写的培训总结" }
    ]
  },
  {
    title: "15 （单选）PCCM专培细则中要求专科基地主任将月度评估反馈给专培医师的频率为（）",
    answer: "D",
    options: [
      { label: "每个月一次" },
      { label: "每2个月一次" },
      { label: "每3个月一次" },
      { label: "每6个月一次" },
      { label: "每12个月一次" }
    ]
  },
  {
    title: "16.（多选）以下关于纤维支气管镜模拟器的描述正确的是",
    answer: "BCD",
    options: [
      { label: "高仿真模拟器优于低仿真模拟器" },
      { label: "可有效评估操作者的经验水平" },
      {
        label: "高仿真模拟器可模拟患者的反应，如呼吸、咳嗽、出血和生命体征变化"
      },
      { label: "低仿真模拟器价廉、易获得" },
      { label: "可完全替代实际纤维气管镜操作" }
    ]
  },
  {
    title: "17.（多选）以下关于模拟教学教师角色的描述正确的是",
    answer: "ABD",
    options: [
      { label: "评估学员技能掌握情况" },
      { label: "反馈、纠正学员的错误" },
      { label: "学员占主导地位，自行练习，教师仅起辅助操作的作用" },
      { label: "在团队情景模拟教学中引导、把握大局" },
      { label: "模拟教学教师主导" }
    ]
  },
  {
    title: "18.（多选）教学查房前主讲老师的准备有哪些内容？",
    answer: "ABC",
    options: [
      { label: "准备教案" },
      { label: "准备病例" },
      { label: "准备患者" },
      { label: "查房后总结" },
      { label: "准备查房器械" }
    ]
  },
  {
    title: "19.（多选）PCCM专科医师需要培训的技能包括哪些项目？",
    answer: "ABCD",
    options: [
      { label: "中心静脉穿刺置管" },
      { label: "呼吸机管理" },
      { label: "气管镜检查" },
      { label: "危重症超声" },
      { label: "腹腔置管" }
    ]
  },
  {
    title: "20.（多选）临床技能带教的形式有哪些？",
    answer: "BC",
    options: [
      { label: "理论讲课" },
      { label: "模拟教学" },
      { label: "临床实际操作" },
      { label: "PBL教学" },
      { label: "小组讨论" }
    ]
  },
  {
    title: "21.（多选）临床技能教学常见误区",
    answer: "ABCD",
    options: [
      { label: "缺乏对危险的预警机制" },
      { label: "缺乏操作后反馈分析" },
      { label: "不予专科医师操作的机会" },
      { label: "对操作过程不监督" },
      { label: "监督、指导临床技能操作过程" }
    ]
  },
  {
    title: "22.（多选）PCCM专科医师门诊带教与病房不同的特点有哪些？",
    answer: "ABCD",
    options: [
      { label: "患者就诊时间短，抓疾病重点" },
      { label: "常见病需要有效准确处理" },
      { label: "专科能力强，处理迅速" },
      { label: "解释清晰、有效" },
      { label: "门诊带教理论教学时间充分" }
    ]
  },
  {
    title: "23.（多选）通过门诊带教学习，PCCM专科医师需要具备的素质有哪些？",
    answer: "ABCD",
    options: [
      { label: "掌握诊断学知识" },
      { label: "具有人文关怀素养" },
      { label: "学会医患沟通技巧" },
      { label: "掌握临床实践知识" },
      { label: "掌握胸部体格检查" }
    ]
  },
  {
    title: "24.（多选）PCCM专培师资门诊带教的目标是什么？",
    answer: "ACDE",
    options: [
      { label: "提高专培教师的门诊教学意识" },
      { label: "提高住院医师的门诊带教意识" },
      { label: "提高专培教师的门诊带教能力" },
      { label: "规范门诊教学的具体内容和教学过程" },
      { label: "规范门诊教学的评价体系和教学管理" }
    ]
  },
  {
    title: "25.（多选）专培医师的课堂教学的特点有哪些？",
    answer: "ABCD",
    options: [
      {
        label:
          "临床实践辅助：专培医师大量时间投入临床实践，课堂教学用于释疑临床遇到的疑难、未决的问题"
      },
      { label: "小班化教学：每个基地每届招生6-10名，允许个体化教学" },
      { label: "师生地位：专培医师在课堂教学中发挥更主要的角色" },
      { label: "充分利用模拟实训中心的作用" },
      { label: "大班理论授课较多" }
    ]
  },
]; 

export { subject, questionnare };
